module.exports = __webpack_public_path__ + "img/nmi-integration-2.e07be702.png";